module.exports = __webpack_public_path__ + "img/41_3.c4a51f69.png";